import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ManagementSaleResponse } from 'api-contract-notices';
import { ConfirmationDialogComponent } from '../../../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { take } from 'rxjs/internal/operators/take';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { SendReportFormComponent } from '../../send-report-form/send-report-form.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'app-sales-toolbar',
	standalone: true,
	imports: [MatToolbarModule, MatButtonModule, TranslateModule, MatDividerModule, MatIconModule, MatTooltipModule],
	templateUrl: './sales-toolbar.component.html',
	styleUrl: './sales-toolbar.component.scss',
})
export class SalesToolbarComponent {
	@Input() scrollToTop: boolean = false;
	@Input() totalItemsCount: number = 0;
	@Input() selectedItems: ManagementSaleResponse[] = [];
	@Output() actionRequested: EventEmitter<any> = new EventEmitter();

	constructor(private matDialog: MatDialog) {}

	checkValidity(type: 'SEND_TO_CLIENTS' | 'DELETE') {
		switch (type) {
			case 'SEND_TO_CLIENTS':
			case 'DELETE': {
				return this.selectedItems.length > 0;
			}
		}
	}

	itemAction(action: 'SEND_TO_CLIENTS' | 'DELETE' | 'SCROLL_TO_TOP' | 'UNSELECT_ALL') {
		switch (action) {
			case 'SEND_TO_CLIENTS': {
				const dialogRef = this.matDialog.open(SendReportFormComponent, {
					width: '600px',
					data: {
						selectedItems: this.selectedItems,
						dataAdministrationType: 'SALES',
					},
				});

				// dialogRef
				// 	.afterClosed()
				// 	.pipe(take(1))
				// 	.subscribe(() => {
				// 		this.actionRequested.emit({ action: 'FILTER' });
				// 	});
				break;
			}
			case 'DELETE': {
				const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
					width: '600px',
					data: {
						type: 'delete-confirmation',
						mode: 'DELETE',
					},
				});

				dialogRef
					.afterClosed()
					.pipe(take(1))
					.subscribe(result => {
						if (result) {
							this.actionRequested.emit({
								action: 'TOOLBAR',
								groupAction: action,
							});
						}
					});

				break;
			}
			case 'UNSELECT_ALL': {
				this.actionRequested.emit({
					action: 'UNSELECT_ALL',
				});
				break;
			}
      default: {
        this.actionRequested.emit({
          action: 'TOOLBAR',
          groupAction: action
        });
      }
		}
	}
}
